<template>
  <div>
    <nav-breadcrumb :menu="[{label: '放款管理'}, {label: '待放款列表'}]"/>
    <el-row>
      <el-col class="grid-content bg-purple">
        <el-row>
          <div class="xzpadd10">
            <data-table
              :tableData="listData"
              :columns="listColumns"
              :pageSize.sync="pageSize"
              :page.sync="page"
              :filters="filters"
            ></data-table>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog title="融资放款" :visible.sync="dialogVisible">
      <pay-financing-component
        :loan-account-list="loanAccountList"
        :pay-account-list="payAccountList"
        :pay-transaction-id="payTransactionId"
        @done="payFinancingDone"
      ></pay-financing-component>
    </el-dialog>
  </div>
</template>

<script>
  import PayFinancingComponent from '../../components/PayFinancingComponent'
  import xhr from '../../../utils/xhr'
  import DataTable from '../../../components/DataTable'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    name: 'ServerAdminFinancingFinancingList',
    data() {
      return {
        pay__cashier: this.$route.query['pay.cashier'] || 'SYSTEM',
        page: 1,
        pageSize: 10,
        listData: {},
        listColumns: [
          {
            name: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            name: '客户姓名',
            field: 'i__contactPerson'
          },
          {
            name: '客户手机号',
            field: 'i__contactTelNo'
          },
          {
            name: '贷款用途',
            field: 'fi__intendedUse'
          },
          {
            name: '放款金额(元)',
            field: 'fi__totalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          // {
          //   name: '放款账户',
          //   field: 'cj__outboundAccountDesc',
          // },
          // {
          //   name: '收款账户',
          //   field: 'cj__inboundAccountDesc',
          // },
          {
            name: '贷款时间',
            field: 'fi__transactionDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            label: '放款状态',
            field: 'fi__transactionStatus',
            formatter: function (r,c,v) {
              return Status2CN('Financing_'+ v)
            }
          },
          {
            name: '操作',
            opts:[
              {
                label: '放款',
                component: 'el-button',
                size: 'mini',
                class: 'el-icon-check',
                type: 'primary',
                clickHandler: (index, row)=>{
                  this.payFinancing(index, row)
                }
              },
            ]
          }
        ],
        filters: {
          form: {
            fi__transactionNo: '',
            u__customerName: '',
            ct__debtorName: '',
            fi__transactionDate: [],
            ct__productName: ''
          },
          columns: [
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'i__contactPerson'
            },
            {
              label: '手机号',
              component: 'el-input',
              field: 'i__contactTelNo'
            },
            {
              label: '贷款用途',
              component: 'el-select',
              field: 'fi__intendedUse',
              options:[]
            },
            {
              label: '申请日期',
              component: 'date-range-picker',
              field: 'fi__transactionDate'
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerFinancingList()
          }
        },
        dialogVisible: false,
        payAccountList: [],
        loanAccountList: [],
        payTransactionId: '',
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.fi.transactionStatus': 'Ready',
            'xlist.search.fi.transactionStatus.op': 'eq',
            // 'xlist.sort.dataField': 'pay.payDate',
            // 'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerFinancingList()
      }
    },
    mounted() {
      this.getCustomerFinancingList()
      this.getBankAccountList()
    },
    components: {
      DataTable,
      PayFinancingComponent
    },
    methods: {
      getCustomerFinancingList: function () {
        xhr.getCustomerFinancingList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.listData = res.data
            }catch(e){

            }
          })

      },
      getBankAccountList: function () {
        xhr.getBankAccountList({},res=>{
          try{
            if(res.data.status == 'success') {
              this.payAccountList = res.data.data||[]
            }
          }catch (e) {

          }
        })
      },
      getDebtorBankAccountList: function (customerId) {
        xhr.getDebtorBankAccountList({
            'c.customerId': customerId
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.loanAccountList = res.data.data||[]
              }
            }catch (e) {

            }
          })
      },
      payFinancing: function (index, row) {
        this.dialogVisible = true
        this.payTransactionId = row.fi__transactionId
        this.getDebtorBankAccountList(row.ct__debtorId)
      },
      payFinancingDone: function () {
        this.dialogVisible = false
        this.getCustomerFinancingList()
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Finance/FinancePaymentPendingPayList.vue